import * as React from "react";
import { Tag } from "../../Tag";
export var MultiSelectTag = React.forwardRef(function (_a, ref) {
    var value = _a.value, label = _a.label, requestRemove = _a.onRequestRemove;
    var onRequestRemove = React.useCallback(function () {
        requestRemove(value);
    }, [value, requestRemove]);
    return (React.createElement(Tag, { ref: ref, className: "bn-multiselect-tag", onRequestRemove: onRequestRemove }, label !== null && label !== void 0 ? label : value));
});
//# sourceMappingURL=MultiSelectTag.js.map